<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew

========================================================================================== -->

<template>
  <vx-card :id="item.id" :class="item.id === activeCourseInfo.id ? 'border-success border-2 border-solid' : ''" v-on="$listeners">
    <div class="vx-row ">
      <div class="vx-col w-1/5 sm:w-0/5 sm:flex hidden items-center align-middle">
        <img :src="item.thumbnail !== null ? item.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'" class="responsive rounded">
      </div>
      <div class="vx-col w-3/5 sm:w-2/5 mt-3">
        <div class="my-2">
          <h5 class="mb-2">{{ item.name }}</h5>
        </div>
        <div class="my-4 ">
          <div class="flex justify-between">
            <small class="font-semibold">Not Started</small>
            <small class="font-semibold">Completed</small>
          </div>
          <vs-progress :percent="progress" class="block mt-1 shadow-md" color="success"></vs-progress>
        </div>
      </div>
      <div class="vx-col w-2/5 align-middle justify-center">
        <vs-button class="shadow-lg font-semibold w-full my-2"
                   icon="icon-play" icon-pack="feather" :color="item.selected ? 'primary' : 'success'"
                   type="gradient" @click="update_active_course(item.id)">Practice
        </vs-button>
        <vs-button class=" shadow-lg font-semibold w-full  my-2 bg-danger-gradient"
                   icon="icon-info" icon-pack="feather" color="danger"
                   type="gradient" @click="show_course_progress(item.id)">
          Progress
        </vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      progress: 0
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    update_active_course (x) {
      this.$emit('update_active_course', x)
    },
    show_course_progress (x) {
      this.$emit('show_course_progress', x)
    }


  },
  mounted () {
    this.$http.get(`progress/user/specific/@me/course/progress?id=${this.item.id}`)
      .then(response => {
        this.progress = response.data.data.completion_percent
      })
  }
}
</script>

<style lang="scss" scoped>
.course-selector-card {

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

    .grid-view-img{
      opacity: 0.9;
    }
  }
}
</style>
